module.exports = __webpack_public_path__ + "img/item_arrow.ac923ed0.svg";